/**
 * 中文（简体）语言包 —— locale key 全集基准（单一事实源）。
 *
 * 命名规范：`{component}.{语义}`，如 empty.noData / modal.ok / pagination.prev。
 * 新增组件内置文案必须先在此补 key（en 包同步补齐，completeness 测试兜底）。
 */
export const zhCN = {
  // badge（徽标）
  'badge.notifications': '{count} 条未读通知',
  // modal（对话框）
  'modal.close': '关闭',
  'modal.ok': '确定',
  'modal.cancel': '取消',
  'modal.maximize': '最大化',
  'modal.restore': '还原',
  // confirm（命令式确认弹窗）
  'confirm.ok': '确定',
  'confirm.cancel': '取消',
  // empty（空态占位）
  'empty.noData': '暂无数据',
  // alert（警告提示）
  'alert.close': '关闭',
  // drawer（抽屉）
  'drawer.close': '关闭',
  'drawer.ok': '确定',
  'drawer.cancel': '取消',
  'drawer.resize': '调整抽屉尺寸',
  // message（全局消息）
  'message.close': '关闭',
  // notification（通知提醒）
  'notification.close': '关闭',
  'notification.region': '通知',
  // notice-bar（通告栏）
  'noticeBar.closeAriaLabel': '关闭',
  'noticeBar.regionLabel': '通告',
  // toast（轻提示）
  'toast.close': '关闭',
  // snackbar（消息条）
  'snackbar.close': '关闭',
  // popconfirm（气泡确认）
  'popconfirm.ok': '确定',
  'popconfirm.cancel': '取消',
  // select（选择器）
  'select.search': '搜索选项',
  'select.placeholder': '请选择',
  'select.empty': '暂无数据',
  'select.noMatch': '无匹配选项',
  'select.remove': '移除 {label}',
  'select.create': '创建 {label}',
  // cascader（级联选择）
  'cascader.placeholder': '请选择',
  // tree-select（树选择）
  'treeSelect.placeholder': '请选择',
  'treeSelect.empty': '暂无数据',
  'treeSelect.join': '、',
  'treeSelect.andMore': '等 {count} 项',
  // auto-complete（自动完成）
  'autoComplete.noMatch': '无匹配结果',
  'autoComplete.defaultLabel': '自动完成输入框',
  // combobox（组合框：输入框即控件，输入过滤 + 选中取值）
  'combobox.empty': '暂无选项',
  'combobox.noMatch': '无匹配选项',
  'combobox.loading': '加载中…',
  // input（输入框）
  // form（表单通用）
  'form.valueMissing': '该字段为必填项',
  'input.clear': '清除',
  'input.defaultLabel': '输入框',
  'textarea.defaultLabel': '多行文本框',
  'input.showPassword': '显示密码',
  'input.hidePassword': '隐藏密码',
  // mentions（提及）
  'mentions.defaultLabel': '提及输入框',
  'mentions.noMatch': '无匹配提及',
  // input-number（数字输入框）
  'inputNumber.increase': '增加',
  'inputNumber.decrease': '减少',
  'inputNumber.defaultLabel': '数字输入框',
  // slider（滑块）
  'slider.valueLabel': '滑块',
  'slider.minLabel': '最小值',
  'slider.maxLabel': '最大值',
  // knob（旋钮）
  'knob.valueLabel': '旋钮',
  // rate（评分）
  'rate.rate': '评分',
  // form（表单校验）
  'form.validationFailed': '校验未通过',
  // tour（漫游引导）
  'tour.skip': '跳过',
  'tour.prev': '上一步',
  'tour.next': '下一步',
  'tour.finish': '完成',
  'tour.close': '关闭',
  'tour.dontShowAgain': '不再显示',
  'tour.hint': '提示',
  'tour.hintGotIt': '知道了',
  'tour.progress': '引导进度',
  // steps（步骤条）
  'steps.prev': '上一步',
  'steps.next': '下一步',
  'steps.optional': '可选',
  // questionnaire（多步问答）
  'questionnaire.prev': '上一步',
  'questionnaire.next': '下一步',
  'questionnaire.submit': '完成',
  'questionnaire.skip': '跳过本步',
  'questionnaire.stepLabel': '第 {current} / {total} 步',
  'questionnaire.optional': '可选',
  // anchor（锚点导航）
  'anchor.nav': '锚点导航',
  // breadcrumb（面包屑）
  'breadcrumb.nav': '面包屑',
  'breadcrumb.expand': '展开被折叠的面包屑项',
  // back-top（回到顶部）
  'backTop.backToTop': '回到顶部',
  // page-header（页头）
  'pageHeader.back': '返回',
  // splitter（分割面板）
  'splitter.adjust': '调整面板宽度',
  'splitter.collapse': '收起面板',
  'splitter.expand': '展开面板',
  // layout（布局容器）
  'layout.sider': '侧边栏',
  // sidebar（可折叠侧栏）
  'sidebar.nav': '侧栏导航',
  'sidebar.toggle': '折叠侧栏',
  'sidebar.expand': '展开侧栏',
  'sidebar.openMenu': '打开侧栏',
  'sidebar.closeMenu': '关闭侧栏',
  'sidebar.resize': '调整侧栏宽度',
  // float-button（悬浮按钮）
  'floatButton.action': '悬浮操作',
  // toggle-group（切换组）
  'toggleGroup.group': '切换组',
  // speed-dial（悬浮动作按钮）
  'speedDial.actions': '操作菜单',
  // pagination（分页）
  'picker.columnLabel': '第 {index} 列',
  'pagination.nav': '分页',
  'pagination.prev': '上一页',
  'pagination.next': '下一页',
  'pagination.first': '首页',
  'pagination.last': '末页',
  'pagination.page': '第 {page} 页',
  'pagination.total': '共 {total} 条',
  'pagination.sizes': '每页条数',
  'pagination.sizePerPage': '{size} 条/页',
  'pagination.goto': '跳至',
  'pagination.pageClassifier': '页',
  'pagination.jumperInput': '页码跳转',
  'pagination.jumpForward': '向前跳页',
  'pagination.jumpBackward': '向后跳页',
  'pagination.more': '更多',
  // table（表格）
  'table.selectAll': '全选',
  'table.exportCsv': '导出 CSV',
  'table.exportExcel': '导出 Excel',
  'table.rowDragHandle': '拖拽排序',
  'table.loading': '加载中…',
  'table.empty': '暂无数据',
  'table.selectRow': '选择行 {key}',
  'table.expand': '展开/收起',
  'table.summary': '合计',
  'table.edit': '编辑',
  'table.save': '保存',
  'table.cancel': '取消',
  'table.editCell': '编辑 {column}（行 {key}）',
  'table.editHint': '双击编辑',
  'table.filter': '筛选',
  'table.clear': '清除',
  'table.groupEmpty': '（空）',
  // list（列表）
  'list.empty': '暂无数据',
  // scheduler（日程调度）
  'scheduler.prev': '上一页',
  'scheduler.next': '下一页',
  'scheduler.today': '今天',
  'scheduler.more': '+{count} 条',
  'scheduler.viewMonth': '月',
  'scheduler.viewWeek': '周',
  'scheduler.viewDay': '日',
  'scheduler.viewAgenda': '日程',
  'scheduler.allDay': '全天',
  'scheduler.noEvents': '此区间无日程',
  // gantt（甘特图）
  'gantt.empty': '暂无任务',
  'gantt.listLabel': '任务列表',
  'gantt.expand': '展开子任务',
  'gantt.collapse': '收起子任务',
  'gantt.milestone': '里程碑',
  'gantt.taskAria': '{name}：{start} 至 {end}，进度 {progress}%',
  'gantt.milestoneAria': '{name}：{date}，里程碑',
  'gantt.today': '今天',
  'gantt.tooltipProgress': '进度 {progress}%',
  'gantt.tooltipRange': '{start} 至 {end}',
  // kanban（看板）
  'kanban.emptyColumn': '拖拽卡片到此处',
  'kanban.moveCard': '移动卡片',
  'kanban.moveUp': '上移',
  'kanban.moveDown': '下移',
  'kanban.groupEmpty': '（空）',
  'kanban.toggleLane': '展开/收起泳道',
  'kanban.dragColumn': '拖拽调整列顺序',
  'kanban.moveLeft': '列左移',
  'kanban.moveRight': '列右移',
  // tree（树形控件）
  'tree.expand': '展开/收起',
  'tree.select': '选择 {label}',
  'tree.loading': '加载中…',
  // timeline（时间轴）
  'timeline.pending': '敬请期待',
  // carousel（轮播）
  'carousel.prev': '上一屏',
  'carousel.next': '下一屏',
  'carousel.dot': '第 {index} 张',
  'carousel.pause': '暂停自动播放',
  'carousel.play': '继续自动播放',
  // image（图片）
  'image.loading': '加载中…',
  'image.loadFailed': '图片加载失败',
  'image.defaultAlt': '图片',
  // image-group（图集容器，共享预览组的 aria 可访问名称）
  'imageGroup.group': '图集',
  // avatar（头像）
  'avatar.defaultAlt': '头像',
  'avatar.changeAvatar': '更换头像',
  'avatar.foldedMembers': '全部成员',
  // typography（排版）
  'typography.copy': '复制',
  // tag（标签）
  'tag.close': '关闭',
  // tag-group（标签组）
  'tagGroup.group': '标签组',
  // swatch（色板）
  'swatch.color': '色板',
  // swatch-group（色板选择组）
  'swatchGroup.group': '色板组',
  // tabs（标签页）
  'tabs.close': '关闭',
  'tabs.ctxClose': '关闭',
  'tabs.ctxNew': '新建',
  'tabs.ctxCloseOthers': '关闭其他',
  'tabs.ctxCloseLeft': '关闭左侧所有',
  'tabs.ctxCloseRight': '关闭右侧所有',
  'tabs.ctxCloseAll': '关闭全部',
  'tabs.add': '新增标签',
  'tabs.newTab': '新标签',
  'tabs.scrollPrev': '向前滚动标签',
  'tabs.scrollNext': '向后滚动标签',
  'tabs.more': '更多标签',
  // button-group（按钮组）
  'buttonGroup.group': '按钮组',
  // compact（紧凑组合容器）
  'compact.group': '紧凑组合',
  // loading（加载态，通用兜底）
  'loading.loading': '加载中…',
  // calendar（日历）
  'calendar.today': '今天',
  'calendar.prevMonth': '上一月',
  'calendar.nextMonth': '下一月',
  'calendar.prevYear': '上一年',
  'calendar.nextYear': '下一年',
  // date-picker（日期选择器）
  'datePicker.placeholder': '请选择日期',
  'datePicker.confirm': '确定',
  'datePicker.join': '、',
  'datePicker.shortcutToday': '今天',
  'datePicker.shortcutThisWeek': '本周',
  'datePicker.shortcutThisMonth': '本月',
  'datePicker.shortcutThisYear': '今年',
  'datePicker.selectMonth': '选择月份',
  'datePicker.selectYear': '选择年份',
  // dropdown（下拉菜单）
  'dropdown.openMenu': '打开菜单',
  // popover（气泡卡片）
  'popover.close': '关闭',
  // menu（菜单）
  'menu.more': '更多菜单项',
  // time-picker（时间选择器）
  'timePicker.placeholder': '请选择时间',
  'timePicker.hour': '时',
  'timePicker.minute': '分',
  'timePicker.second': '秒',
  // upload（上传）
  'upload.select': '选择文件',
  'upload.drag': '拖拽文件到此处，或点击选择文件',
  'upload.remove': '移除 {name}',
  'upload.upload': '开始上传',
  'upload.empty': '暂无文件',
  'upload.maxCount': '最多上传 {max} 个文件',
  'upload.preview': '预览 {name}',
  'upload.previewDialog': '文件预览',
  'upload.closePreview': '关闭预览',
  // transfer（穿梭框）
  'transfer.source': '源列表',
  'transfer.target': '已选列表',
  'transfer.toRight': '移至右侧',
  'transfer.toLeft': '移至左侧',
  'transfer.selectAll': '全选',
  'transfer.search': '搜索',
  'transfer.empty': '暂无数据',
  'transfer.noMatch': '未找到匹配项',
  // color-picker（颜色选择器）
  'colorPicker.label': '颜色选择器',
  'colorPicker.preset': '预设颜色',
  'colorPicker.hue': '色相',
  'colorPicker.saturation': '饱和度',
  'colorPicker.brightness': '亮度',
  'colorPicker.red': '红',
  'colorPicker.green': '绿',
  'colorPicker.blue': '蓝',
  // pin-input（验证码分格输入）
  'pinInput.group': '验证码',
  'pinInput.digit': '第 {position} 位',
  // dynamic-input（动态列表）
  'dynamicInput.add': '添加',
  'dynamicInput.remove': '删除',
  // dynamic-tags（动态标签）
  'dynamicTags.inputLabel': '添加标签',
  'dynamicTags.remove': '移除 {label}',
  'dynamicTags.duplicate': '标签已存在',
  // editable（就地编辑）
  'editable.edit': '编辑',
  'editable.submit': '确定',
  'editable.cancel': '取消',
  // ellipsis（文本省略）
  'ellipsis.expand': '展开',
  'ellipsis.collapse': '收起',
  // chart（图表）
  'chart.line': '折线图',
  'chart.bar': '柱状图',
  'chart.pie': '饼图',
  'chart.area': '面积图',
  'chart.donut': '环形图',
  'chart.stacked-bar': '堆叠柱状图',
  'chart.radar': '雷达图',
  'chart.polar-area': '极坐标面积图',
  'chart.empty': '暂无数据',
  // code（代码块）
  'code.copy': '复制',
  'code.copied': '已复制',
  // image（图片预览浮层）
  'image.preview.close': '关闭预览',
  'image.preview.zoomIn': '放大',
  'image.preview.zoomOut': '缩小',
  'image.preview.rotate': '旋转',
  'image.preview.download': '下载',
  'image.preview.alt': '图片预览',
  'image.preview.flipX': '水平翻转',
  'image.preview.flipY': '垂直翻转',
  'image.preview.prev': '上一张',
  'image.preview.next': '下一张',
  'image.preview.progress': '第 {index} 张，共 {total} 张',
  // qrcode（二维码）
  'qrcode.image': '二维码',
  'qrcode.empty': '暂无内容',
  'qrcode.tooLong': '内容过长，请缩短后重试',
  'qrcode.expired': '二维码已过期',
  'qrcode.refresh': '刷新',
  'qrcode.loading': '加载中…',
  'qrcode.scanned': '已扫描',
  // barcode（条码）
  'barcode.image': '条码',
  'barcode.empty': '暂无内容',
  'barcode.invalid': '内容不符合所选码制的编码规则',
  'barcode.invalidCharset': '包含码制不允许的字符',
  'barcode.invalidLength': '位数不符合码制要求',
  'barcode.invalidChecksum': '校验位不正确',
  // command（命令面板）
  'command.placeholder': '搜索命令…',
  'command.empty': '无匹配命令',
  'command.search': '搜索命令',
  'command.label': '命令面板',
  'command.loading': '正在加载命令…',
  'command.noResults': '未找到与「{query}」匹配的命令',
  'command.recent': '最近使用',
  'command.back': '返回上一级',
  'command.footer.navigate': '选择',
  'command.footer.select': '执行',
  'command.footer.close': '关闭',
  'command.multiRun': '执行 {n} 项',
  // menubar（应用菜单栏）
  'menubar.label': '菜单栏',
  'menubar.menu': '菜单',
  'menubar.more': '更多菜单项',
  // navigation-menu（多级导航）
  'navigationMenu.label': '导航',
  'navigationMenu.back': '返回',
  // toolbar（工具栏）
  'toolbar.label': '工具栏',
  'toolbar.more': '更多工具',
  'toolbar.toggleGroup': '切换组',
  'toolbar.input': '工具栏输入框',
  'toolbar.item': '工具栏项',
  // app-bar（应用栏）
  'appBar.label': '应用栏',
  'appBar.menu': '主菜单',
  'appBar.more': '更多操作',
  'appBar.item': '操作项',
  // log（日志流）
  'log.empty': '暂无日志',
  'log.no-match': '无匹配日志',
  // theme-editor（主题编辑器）
  'themeEditor.label': '主题编辑器',
  'themeEditor.export': '导出主题 JSON',
  'themeEditor.search': '搜索 token',
  'themeEditor.group.color': '颜色',
  'themeEditor.group.fontSize': '字号',
  'themeEditor.group.space': '间距',
  'themeEditor.group.radius': '圆角',
  'themeEditor.group.controlHeight': '控件高度',
  'themeEditor.group.custom': '其他',
  // bottom-navigation（底部导航）
  'bottomNavigation.nav': '底部导航',
  'upload.retry': '重试 {name}',
  'upload.cancelUpload': '取消上传 {name}',
  'transfer.count': '{selected}/{total}',
  'dynamicTags.patternMismatch': '格式不正确',
  'dynamicInput.moveUp': '上移',
  'dynamicInput.moveDown': '下移',
  'timePicker.now': '此刻',
  'datePicker.shortcutThisQuarter': '本季度',
  // index-bar（索引栏）
  'indexBar.navAriaLabel': '字母索引导航',
  'indexBar.listLabel': '分节列表',
  // swipe-cell（滑动操作）
  'swipeCell.actionsLabel': '滑动操作',
  // pull-refresh（下拉刷新）
  'pullRefresh.pull': '下拉刷新',
  'pullRefresh.release': '松开立即刷新',
  'pullRefresh.refreshing': '刷新中…',
  'pullRefresh.success': '刷新成功',

  // conversation（会话族：bubble/attachment/message-scroller/message-row）
  'bubble.loading': '正在输入…',
  'bubble.reactions': '表情回应',
  'attachment.remove': '移除 {name}',
  'attachment.download': '下载 {name}',
  'attachment.error': '上传失败',
  'attachment.group': '附件组',
  'messageScroller.label': '消息列表',
  'messageScroller.scrollToBottom': '滚动到底部',
  'messageRow.status.sending': '发送中',
  'messageRow.status.sent': '已发送',
  'messageRow.status.delivered': '已送达',
  'messageRow.status.read': '已读',
  'messageRow.status.error': '发送失败',
  // workbench（工作台构件族）
  'titlebar.label': '标题栏',
  'titlebar.windowControls': '窗口控制',
  'titlebar.docTitle': '文档标题',
  'titlebar.minimize': '最小化',
  'titlebar.maximize': '最大化',
  'titlebar.close': '关闭',
  'statusbar.label': '状态栏',
  'inspector.label': '属性面板',
  'inspector.mixed': '混合值',
  'inspector.reset': '复位',
  'inspector.empty': '未选中对象',
  'actionBar.label': '操作栏',
  'actionBar.progress': '任务进度',
  'actionBar.cancel': '取消任务',
  'actionBar.seek': '跳转到指定帧',
} as const
